import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useCustomDialogTitleStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: hubloTheme.spacing(2, 2, 1),

    [hubloTheme.breakpoints.up('lg')]: {
      padding: hubloTheme.spacing(2, 3, 1),
    },
  },
  closeButton: {
    color: hubloTheme.palette.common.black,
    marginRight: 0,
  },
}))
